import { ReactNode } from 'react';
import { AnalysisErrorStatus } from '../../utils/apollo/graphqlSchema';
import { IAnalysisResponse } from '../../utils/apollo/responseTypes';
export interface IErrorMessageProps {
  title: ReactNode;
  description?: ReactNode;
}

export enum ChartMode {
  View = 'VIEW',
  Build = 'BUILD',
  Compact = 'COMPACT',
}

export enum ChartViewType {
  Default = 'DEFAULT',
  FallbackError = 'FALLBACK_ERROR',
  NoData = 'NO_DATA',
  Cancelled = 'CANCELLED',
  KobolError = 'KOBOL_ERROR',
  CustomError = 'CUSTOM_ERROR',
  PermissionError = 'PERMISSION_ERROR',
}

export type IChartError =
  | { type: ChartViewType.FallbackError }
  | { type: ChartViewType.PermissionError }
  | { type: ChartViewType.NoData }
  | { type: ChartViewType.Cancelled }
  | {
      type: ChartViewType.CustomError;
      title: ReactNode;
      description?: ReactNode;
    }
  | {
      type: ChartViewType.KobolError;
      analysisId: string;
      errorStatus: AnalysisErrorStatus;
      failureMsg: IAnalysisResponse['failureMsg'];
    };

export type IChartView = IChartError | { type: ChartViewType.Default };
